import { EKey } from '../repositories/newbuilding-promos/entities/sort_variant/SortVariantSchema';
import { TSearchPromosResponse_1 } from '../repositories/newbuilding-promos/v2/search-promos';
import { ESortVariants } from '../types/jsonQuery/sortType';
import { ISortVariant } from '../types/sortVariant';

const SORT_VARIANTS_MAP = new Map([
  [EKey.NewFirst, ESortVariants.NewFirst],
  [EKey.Popularity, ESortVariants.Popularity],
  [EKey.AboutToEnd, ESortVariants.AboutToEnd],
]);

export const mapSortVariants = (promosResponse: TSearchPromosResponse_1): ISortVariant[] => {
  return promosResponse.sortVariants.map(item => ({
    key: SORT_VARIANTS_MAP.get(item.key) as ESortVariants,
    value: item.value,
  }));
};
